import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import LiveTrips from 'pages/live-trips';
import SearchResult from 'pages/search/search-results';
import Search from 'pages/search';
import KitchenInventory from 'pages/kitchen/inventory';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';
import KitchenTeamStats from 'pages/kitchen/kitchen-team-stats';
import TeamList from 'pages/kitchen/settings/team-list';
import TeamOfTheMonth from 'pages/kitchen/settings/team-of-the-month';
import TopMembersOfTheMonth from 'pages/kitchen/settings/top-members-of-the-month';
import NoticeBoard from 'pages/kitchen/settings/notice-board';
import SettingsIndex from 'pages/kitchen/settings';
import SettingsLayout from 'pages/kitchen/settings/layout';
import DashboardLayout from 'layouts/dashboard.layout';
import ManageTraffic from 'pages/kitchen/manage-traffic';
import WeeklyRoster from 'pages/kitchen/settings/weekly-roster';
import ReviewRoster from 'pages/kitchen/settings/review-roster';
import EditRoster from 'pages/kitchen/settings/edit-roster';
import WeeklyRosterLayout from 'layouts/weekly-roster.layout';
import { getInitialRoute } from 'utils/role-config';
import PackagingScreens from 'pages/kitchen/settings/packaging-screens';
import TeamListLayout from 'layouts/team-list.layout';
import UserProfile from 'pages/user';
import ClearLocalStorage from 'pages/clear-local-storage';
import MealProductionTracker from 'pages/kitchen/meal-production-tracker';
import { TeamListProvider } from 'contexts/team-list.context';

const TEAM_LIST_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <TeamList />
  }
];

const WEEKLY_ROSTER_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <WeeklyRoster />
  },
  {
    path: KITCHEN_ROUTE_KEYS.REVIEW_WEEKLY_ROSTER,
    element: <ReviewRoster />
  },
  {
    path: KITCHEN_ROUTE_KEYS.EDIT_WEEKLY_ROSTER,
    element: <EditRoster />
  }
];

const SETTINGS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <SettingsIndex />
  },
  {
    path: KITCHEN_ROUTE_KEYS.TEAM_LIST,
    element: <TeamListLayout />,
    children: TEAM_LIST_ROUTES
  },
  {
    path: KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER,
    element: (
      <TeamListProvider>
        <WeeklyRosterLayout />
      </TeamListProvider>
    ),
    children: WEEKLY_ROSTER_ROUTES
  },
  {
    path: KITCHEN_ROUTE_KEYS.TEAM_OF_THE_MONTH,
    element: <TeamOfTheMonth />
  },
  {
    path: KITCHEN_ROUTE_KEYS.TOP_MEMBERS_OF_THE_MONTH,
    element: <TopMembersOfTheMonth />
  },
  {
    path: KITCHEN_ROUTE_KEYS.NOTICE_BOARD,
    element: <NoticeBoard />
  },
  {
    path: KITCHEN_ROUTE_KEYS.PACKAGING_SCREENS,
    element: <PackagingScreens />
  }
];
const KITCHEN_CHILD_ROUTES: RouteObject[] = [
  {
    path: KITCHEN_ROUTE_KEYS.DASHBOARD,
    element: <Navigate to={getInitialRoute()} />
  },
  {
    path: KITCHEN_ROUTE_KEYS.LIVE_TRIPS,
    element: <LiveTrips />
  },
  {
    path: KITCHEN_ROUTE_KEYS.CLEAR_STORAGE,
    element: <ClearLocalStorage />
  },

  {
    path: KITCHEN_ROUTE_KEYS.SEARCH,
    element: <Search />
  },
  {
    path: KITCHEN_ROUTE_KEYS.SEARCH_RESULT,
    element: <SearchResult />
  },
  {
    path: KITCHEN_ROUTE_KEYS.INVENTORY,
    element: <KitchenInventory />
  },

  {
    path: KITCHEN_ROUTE_KEYS.NOTICE_BOARD,
    element: <NoticeBoard />
  },

  {
    path: KITCHEN_ROUTE_KEYS.TEAM_STATS,
    element: <KitchenTeamStats />
  },
  {
    path: KITCHEN_ROUTE_KEYS.MANAGE_TRAFFIC,
    element: <ManageTraffic />
  },
  {
    path: KITCHEN_ROUTE_KEYS.USER_PROFILE,
    element: <UserProfile />
  },
  {
    path: KITCHEN_ROUTE_KEYS.SETTINGS,
    element: <SettingsLayout />,
    children: SETTINGS_ROUTES
  },
  {
    path: KITCHEN_ROUTE_KEYS.MEAL_PRODUCTION_TRACKER,
    element: <MealProductionTracker />
  }
];

export const KITCHEN_ROUTES: RouteObject[] = [
  {
    path: KITCHEN_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: KITCHEN_CHILD_ROUTES
  }
];
